import { useState } from 'react';

type ProductIconProps = {
  name: string;
  src: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const sizeClass = {
  sm: 'h-12 w-12 min-h-[3rem] min-w-[3rem] text-lg',
  md: 'h-16 w-16 min-h-[4rem] min-w-[4rem] text-xl',
  lg: 'h-24 w-24 min-h-[6rem] min-w-[6rem] text-3xl',
};

const initials = (name: string) =>
  name
    .replace(/—/g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase() || '?';

const ProductIcon = ({ name, src, size = 'md', className = '' }: ProductIconProps) => {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        className={`rounded-2xl bg-gradient-brand flex items-center justify-center font-display font-bold text-white shadow-card ring-1 ring-slate-200/80 ${sizeClass[size]} ${className}`}
        role="img"
        aria-label={`${name} app icon`}
      >
        {initials(name)}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={`${name} app icon`}
      width={size === 'lg' ? 96 : size === 'md' ? 64 : 48}
      height={size === 'lg' ? 96 : size === 'md' ? 64 : 48}
      className={`rounded-2xl object-cover shadow-card ring-1 ring-slate-200/80 bg-white ${sizeClass[size]} ${className}`}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
};

export default ProductIcon;
